<template>
  <div>
    <v-dialog
      v-model="edit_dialog"
      persistent
      scrollable
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card v-if="edit_dialog">
        <v-card-title>
          Editando depósito
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="editForm" class="mt-2">
            <v-row justify="center">
              <v-col cols="10" class="pa-0 pt-3">
                <!-- tem que por os items com um request dos clients -->
                <!-- <v-select label="Cliente" prepend-icon="mdi-star" v-model="edit_deposit.client_id" :rules="required"></v-select> -->
                <v-autocomplete
                  v-if="!deposit.confirmed"
                  v-model="edit_deposit.client_id"
                  :items="all_clients"
                  :item-text="formatClientDisplayName"
                  item-value="id"
                  label="Cliente"
                  :loading="loading_clients"
                  :readonly='loading_clients'
                  prepend-icon="mdi-star"
                  :rules="required"
                  :filter="filterClients"
                >
                  <template v-slot:selection="{item}">
                    <v-sheet width="100%" class="d-flex flex-column justify-start mt-2">
                      <span> {{ formatClientDisplayName(item) }} <span v-if="item.fantasyName">({{ item.fantasyName }})</span> </span>
                      <div class="d-flex justify-space-between mt-1 align-center">
                        <span class="caption">ID: {{item.id}}</span>
                        <span class="caption">Cidade: {{ item.city }} </span>
                      </div>
                    </v-sheet>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title class="pb-1"> Nome/Rz social: <b> {{ formatClientDisplayName(item) }} </b> </v-list-item-title>
                      <v-list-item-subtitle class="mb-1" v-if="item.fantasyName && item.fantasyName != item.name">Nome fantasia: <b> {{item.fantasyName}} </b></v-list-item-subtitle>
                      <v-list-item-subtitle class="d-flex justify-space-between">
                        <div>ID: <b>{{ item.id }} </b> </div>
                        <div>Cidade: <b>{{ item.city }}</b></div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="5" class="py-0">
                <v-select label="Banco" :items="company_banks" v-model="edit_deposit.deposit_bank" :rules="required"></v-select>
              </v-col>
              <v-col cols="5" class="py-0">
                <SelectCompany @newCompany="handleNewCompany" :company="edit_deposit.deposit_company"></SelectCompany>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="6" class="d-flex justify-center pa-0" v-if="!deposit.confirmed">
                <v-checkbox label="Alterar valores" v-model="edit_values"></v-checkbox>
              </v-col>
              <v-col cols="6" class="d-flex justify-center pa-0">
                <v-checkbox label="Alterar data" v-model="edit_date"></v-checkbox>
              </v-col>
            </v-row>
            <template v-if="edit_date == true">
              <v-row justify="center">
                <v-col cols="7" class="pa-0">
                  <v-menu v-model="menu_date" :close-on-content-click="false" offset-y transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="edit_deposit.deposit_date? $moment(edit_deposit.deposit_date).format('L') : null" label="Data do depósito" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :rules="required"></v-text-field>
                    </template>
                    <v-date-picker v-model="edit_deposit.deposit_date" @input="menu_date = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </template>
            <template v-if="edit_values == true">
              <v-row justify="center" class="pa-2">
                <v-col cols="7" class="pa-0">
                  <v-text-field label="À vista" :hint="originalValue(deposit.entrance_value)" v-currency="currency" v-model="edit_deposit.entrance_value" persistent-hint :rules="required"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="pa-2">
                <v-col cols="7" class="pa-0">
                  <v-text-field label="1 dia bloqueado" :hint="originalValue(deposit.one_day_value)" v-currency="currency" v-model="edit_deposit.one_day_value" persistent-hint :rules="required"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="pa-2">
                <v-col cols="7" class="pa-0">
                  <v-text-field label="2 dias bloqueado" :hint="originalValue(deposit.two_days_value)" v-currency="currency" v-model="edit_deposit.two_days_value" persistent-hint :rules="required"></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row justify="center" class="pa-2">
                <v-col cols="7" class="pa-0">
                  <v-text-field label="Total" readonly :hint="originalValue(deposit.value)" :value="edit_deposit_value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" persistent-hint></v-text-field>
                </v-col>
              </v-row>
            </template>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <f-btn @click="$emit('closeEditDialog')" cancel></f-btn>
          <f-btn @click="submitDeposit()" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading_saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'
import clientDisplay from '@/mixins/clientDisplay'
import Api from '@/api/index';

export default {
  name:"EditDepositDialog",
  props: {
    deposit: {
      type: Object
    },
    edit_dialog: {
      type: Boolean
    }
  },
  mixins: [
    validations,
    clientDisplay
  ],
  directives: {
    currency: CurrencyDirective,
  },
  components:{
    SelectCompany: () => import("@/_backoffice/_registrations/components/shared/SelectCompany.vue"),
  },
  data() {
    return {
      edit_deposit: {
        entrance_value: '0.00',
        one_day_value: '0.00',
        two_days_value: '0.00',
        deposit_date: null
      },
      edit_values: false,
      edit_date: false,
      menu_date: false,

      loading_clients: false,
      all_clients: [],


      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      company_banks: ['Itaú','Sicoob','Caixa','Banco do Brasil'],

      loading_saving: false,
    }
  },
  methods: {
    getAllClients() {
      this.loading_clients = true
      Api.Client.index({short: true, modality_id: this.activeModalityId}).then(r => r.data).then(r => {
        r = r.data? r.data.map(d => d.attributes) : r
        this.all_clients = [...r]
        // this.all_clients = r.map(r => r.client)
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{
        this.loading_clients = false
      })
    },
    filterClients (item, queryText, itemText) {
      const name = item.name ? item.name.toLowerCase() : ''
      const corporate_name = item.corporateName ? item.corporateName.toLowerCase() : ''
      const fantasyName = item.fantasyName ? item.fantasyName.toLowerCase() : ''
      const city = item.city ? item.city.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || corporate_name.indexOf(searchText) > -1 || fantasyName.indexOf(searchText) > -1 || city.indexOf(searchText) > -1 || id.indexOf(searchText) > -1
    },
    originalValue(original_value) {
      return `Valor original: ${Number(original_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`
    },
    submitDeposit() {
      if (this.$refs.editForm.validate()) {
        let c = confirm('Deseja atualizar depósito?')
        if (c){
          this.updateDeposit()
        }
      }
    },
    updateDeposit(){
      const { id, client_id, deposit_bank, deposit_company, deposit_date, entrance_value, one_day_value, two_days_value, value, } = this.edit_deposit
      let obj = {
        id, client_id, deposit_bank, deposit_company, 
      }
      if (this.edit_values){
        obj = {
          ...obj, 
          entrance_value: Number(entrance_value.replace(/,/g, '')), 
          one_day_value: Number(one_day_value.replace(/,/g, '')) > 0 ? Number(one_day_value.replace(/,/g, '')) : null, 
          two_days_value: Number(two_days_value.replace(/,/g, '')) > 0 ? Number(two_days_value.replace(/,/g, '')) : null, 
          value,
        }
      }
      if (this.edit_date){
        obj = {
          ...obj, 
          deposit_date,
        }
      }
      this.loading_saving = true
      Api.Deposit.update(obj).then(r => r.data).then(r => {
        this.$emit('doneUpdate', r)
      }).catch(error => {
        console.log(error)
      }).finally(()=>{
        this.loading_saving = false
      })
    },
    setupEditDeposit(){
      this.edit_deposit = {
        ...this.deposit,
        ...this.edit_deposit,
      };
      this.edit_values = false
      this.edit_date = false
      this.menu_date = false

      this.getAllClients()
    },
    handleNewCompany(new_company){
      this.edit_deposit.deposit_company = new_company
    },
  },
  computed: {
    edit_deposit_value() {
      const { entrance_value, one_day_value, two_days_value} = this.edit_deposit
      let total = Number(entrance_value.replace(/,/g, '')) + Number(one_day_value.replace(/,/g, '')) + Number(two_days_value.replace(/,/g, ''))
      this.edit_deposit.value = total
      return total 
    },
  },
  watch: {
    edit_date(nv,ov) {
      if (nv){
      } else if (nv == false){
        this.edit_deposit.deposit_date = null
      }
    },
    edit_dialog(nv,ov) {
      if (nv){
        this.setupEditDeposit()
      } else if (nv == false){
        this.edit_deposit = {
          entrance_value: '0.00',
          one_day_value: '0.00',
          two_days_value: '0.00',
          deposit_date: null
        }
      }
    }
  },
}
</script>